module.exports = __webpack_public_path__ + "media/images/game/zs_2019/vydaje-3d3941ab1bef815f96973ff65f49ec79.png";